export default __webpack_public_path__ + "img/bjhhNvJS.e49d03e7.svg";